import { createStore, applyMiddleware, compose } from "redux";
import {thunk} from "redux-thunk";
import logger from 'redux-logger'
import rootReducer from "./reducers";

const initialState = {};
const middleware = [thunk];
const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(
        ...middleware,
        logger
    )
)

export default store;
